import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';

export const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-secondary-50 flex flex-col items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary-600">404</h1>
        <h2 className="mt-4 text-3xl font-bold text-secondary-900">
          Page Not Found
        </h2>
        <p className="mt-2 text-lg text-secondary-600">
          The page you are looking for does not exist or has been moved.
        </p>
        <div className="mt-8">
          <Link to="/dashboard">
            <Button size="lg">
              Go to Dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
